import LoadingSpinner from '@/components/LoadingSpinner';
import { BookmarkCategories } from '@/helpers/constants';
import { useFetchJiraUsersProjectAssignable } from '@http/queries';
import { Box } from '@mui/material';
import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import {
    BrokenLinksExport,
    IssuesExport,
    PagesExport,
    PdfExport,
    SiteIssuesExport,
} from './exportHandlersByCategory';
import IssueExportForm from './IssueExportForm';

const exportHandlersByCategory = {
    [BookmarkCategories.ISSUE]: IssuesExport,
    [BookmarkCategories.SITE]: PagesExport,
    [BookmarkCategories.PDFS_UPLOAD]: PdfExport,
    [BookmarkCategories.PDFS_FOUND]: PdfExport,
    [BookmarkCategories.TOP_ISSUE]: IssuesExport,
    [BookmarkCategories.BROKEN_LINKS]: BrokenLinksExport,
    [BookmarkCategories.SITE_ISSUE]: SiteIssuesExport,
};

export const JiraIssueExport = forwardRef(function JiraIssueExportRef(
    { todo, jiraProject, linkedJiraUserID },
    ref
) {
    const { data: jiraUsers } = useFetchJiraUsersProjectAssignable(jiraProject.key);
    const issueExportFormRef = useRef();

    useImperativeHandle(ref, () => ({
        async handlePost() {
            if (!issueExportFormRef.current.handlePost) return false;
            const response = await issueExportFormRef.current.handlePost();
            return response;
        },
    }));

    if (!jiraUsers) return <LoadingSpinner />;

    console.log('JiraIssueExport_todo', todo);

    const ExportFromElem = exportHandlersByCategory[todo.category];
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {React.createElement(ExportFromElem ?? IssueExportForm, {
                ...(ExportFromElem
                    ? { issueExportFormRef: issueExportFormRef }
                    : { ref: issueExportFormRef }),
                todosToExport: [todo],
                jiraProject,
                jiraUsers,
                linkedJiraUserID,
            })}
        </Box>
    );
});
